import FilterPanelHeader from '~/shared/components/filters/FilterPanelHeader';
import SearchBar from '~/shared/components/SearchBar';

interface ExplorationFilterPanelHeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onClose?: () => void;
  onClearAll?: () => void;
  hasActiveFilters?: boolean;
}

export default function ExplorationFilterPanelHeader({
  searchQuery,
  onSearchChange,
  onClose,
  onClearAll,
  hasActiveFilters = false,
}: ExplorationFilterPanelHeaderProps) {
  return (
    <div className="flex flex-col border-b border-gray-300 shrink-0">
      <FilterPanelHeader
        onClose={onClose}
        onClearAll={onClearAll}
        hasActiveFilters={hasActiveFilters}
      />
      <div className="-mt-3 px-6 pb-6" data-exploration-filter-panel-search>
        <SearchBar
          size="sm"
          placeholder="Search…"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full"
          inputClassName="placeholder:text-gray-600!"
          useSmallSearchIcon
        />
      </div>
    </div>
  );
}
